/**
 * Launch flag for "Base + add-ons" pricing on the public website.
 *
 * The new pricing copy has to merge before launch day, so every surface that
 * quotes a plan price or names a tier (pricing page, FAQ + JSON-LD, SEO, the
 * ROI calculator, industry and homepage copy) switches on this one helper.
 * With the flag unset each surface renders exactly what it rendered before.
 *
 * `NEXT_PUBLIC_*` is inlined at build time, so flipping it needs a redeploy.
 * Plan: MODULAR_SIGNUP_BASE_PLUS_ADDONS_PLAN.md §4.4 "Pricing page", §6 step 5.
 *
 * After launch: delete the legacy branch at every `isModularPricing()` call
 * site, then this file.
 */
export function isModularPricing() {
  return process.env.NEXT_PUBLIC_MODULAR_PRICING === 'true';
}

/**
 * The entry paid plan's name on PUBLIC pages (signup): "Base" once modular
 * pricing is live, "Commerce" before, matching the public pricing page. Inside
 * the app the plan is "Base" as soon as the server's catalog renames the preset
 * (every gate overlay reads the catalog label), so in-app copy says Base directly.
 */
export function entryPlanName() {
  return isModularPricing() ? 'Base' : 'Commerce';
}

export default isModularPricing;
